import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import { queryClient } from '@src/core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

export const subscribeToFreeTrial = async (id: number) => {
  return await request({
    url: `plans/${id}/trial/`,
    method: 'POST',
  });
};

export const useSubscribeToFreeTrial = () => {
  return useMutation({
    mutationFn: subscribeToFreeTrial,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getCurrentSubscription],
      });
      toast.success('Your free trial has been started successfully!');
    },
  });
};
